const map = {
	"./add.svg": 9719,
	"./back.svg": 8103,
	"./close.svg": 8838,
	"./delivery.svg": 7162,
	"./exchange.svg": 2269,
	"./live.svg": 844,
	"./minus.svg": 4822,
	"./more-arrow.svg": 7049,
	"./more.svg": 205,
	"./order.svg": 1874,
	"./other.svg": 7196,
	"./payment.svg": 4140,
	"./product.svg": 6399,
	"./refresh.svg": 9359,
	"./reply.svg": 7630,
	"./search.svg": 4781,
	"./send.svg": 5012,
	"./settings.svg": 7305,
	"./warning.svg": 6638
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7046;